
import React from 'react';
import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

const Home = lazy(() => import('../pages/home/page'));
const Directory = lazy(() => import('../pages/directory/page'));
const Events = lazy(() => import('../pages/events/page'));
const Ministries = lazy(() => import('../pages/ministries/page'));
const Live = lazy(() => import('../pages/live/page'));
const Tools = lazy(() => import('../pages/tools/page'));
const ResourcesHub = lazy(() => import('../pages/resources-hub/page'));
const ChurchProfile = lazy(() => import('../pages/church-profile/page'));
const ClaimChurch = lazy(() => import('../pages/claim-church/page'));
const AdminLogin = lazy(() => import('../pages/admin-login/page'));
const AdminDashboard = lazy(() => import('../pages/admin-dashboard/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'directory',
        element: <Directory />,
      },
      {
        path: 'events',
        element: <Events />,
      },
      {
        path: 'ministries',
        element: <Ministries />,
      },
      {
        path: 'live',
        element: <Live />,
      },
      {
        path: 'tools',
        element: <Tools />,
      },
      {
        path: 'resources-hub',
        element: <ResourcesHub />,
      },
      {
        path: 'church/:id',
        element: <ChurchProfile />,
      },
      {
        path: 'claim-church',
        element: <ClaimChurch />,
      },
      {
        path: 'admin-login',
        element: <AdminLogin />,
      },
      {
        path: 'admin-dashboard',
        element: <AdminDashboard />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;
